export default __webpack_public_path__ + "static/media/RDR2.e640ed3b.jpg";